import { render, staticRenderFns } from "./index.vue?vue&type=template&id=643a6d75&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=643a6d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a6d75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643a6d75')) {
      api.createRecord('643a6d75', component.options)
    } else {
      api.reload('643a6d75', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=643a6d75&scoped=true&", function () {
      api.rerender('643a6d75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoodsGroup/publishGoods/index.vue"
export default component.exports